import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';

function BgOrbs() {
    return (
        <div className="bgOrbs" aria-hidden="true">
            <span className="bgOrb bgOrb--a" />
            <span className="bgOrb bgOrb--b" />
            <span className="bgOrb bgOrb--c" />
            <span className="bgOrb bgOrb--d" />
        </div>
    );
}

export function Layout() {
    const { pathname } = useLocation();

    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

    return (
        <div className="appShell">
            <BgOrbs />
            <Header />
            <main className="appMain pageEnter" key={pathname}>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
